// extracted by mini-css-extract-plugin
module.exports = {"club":"Club_club__1YHbW","title_open":"Club_title_open__aOVic","title_close":"Club_title_close__3E7O0"};